export default __webpack_public_path__ + "media/siteware/favicon-144-17d83060b0e934216dda99954151681e.png";